import { createAction, props } from '@ngrx/store';

import { Portals } from '@qwyk/models';

import { CustomFieldsEntity } from './custom-fields.models';

export const init = createAction(
    '[CustomFields Page] Init',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ parent: Portals.ParentEntity; query: any }>()
);

export const loadCustomFieldsSuccess = createAction(
    '[CustomFields/API] Load CustomFields Success',
    props<{ customFields: CustomFieldsEntity[] }>()
);

export const loadCustomFieldsFailure = createAction(
    '[CustomFields/API] Load CustomFields Failure',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ error: any }>()
);

export const reset = createAction('[CustomFields/API] reset');
